"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const client_1 = require("@apollo/client");
const mutation = (0, client_1.gql) `
  mutation setUserOrgContextId($orgId: String) {
    setUserOrgContextId(orgId: $orgId) {
      token
    }
  }
`;
exports.default = mutation;
//# sourceMappingURL=setUserOrgContextId.mutation.js.map